import jQuery from "jquery";
import * as bootstrap from "bootstrap";
import * as Popper from "@popperjs/core";
import wNumb from "wnumb";
import KTUtil from "@/js/components/util.js";
import KTEventHandler from "@/js/components/event-handler.js";

window.jQuery = window.$ = jQuery;
window.bootstrap = bootstrap;
window.Popper = Popper;
window.wNumb = wNumb;
window.KTUtil = KTUtil;
window.KTEventHandler = KTEventHandler;
